import styled from 'styled-components';
import { Label } from 'styles/elements/label';
import Input from 'styles/elements/input';
import { ColumnDiv, Div } from 'styles/elements/div';
import media from 'styles/media';
import { SecondaryButton } from 'styles/elements/buttons/primaryCare';

const BMI = styled(ColumnDiv)``;

const InputContainer = styled(ColumnDiv)`
  flex: 0 1 calc(50% - 20px);
  margin-right: 20px;
  ${media.extraSmallAndBelow`
    margin-right: 8px;
  `}
`;

BMI.Input = Input;
BMI.Div = styled.div``;
BMI.Label = Label;
BMI.Text = styled.p``;
BMI.InputContainer = InputContainer;
BMI.FlexContainer = Div;
BMI.MeasureToggleButton = SecondaryButton;

export default BMI;
